import { render, staticRenderFns } from "./DescargarResumenVentasModal.vue?vue&type=template&id=4a4919cd"
import script from "./DescargarResumenVentasModal.vue?vue&type=script&setup=true&lang=js"
export * from "./DescargarResumenVentasModal.vue?vue&type=script&setup=true&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports